import React from "react";
import { useEffect } from "react";
import Highlights from "../Component/Highlights";
import { useLocation, NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
const Header = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <div className="headtop">
        <div className="headlink">
          <div className="headlinkimg">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/phoneicn.png"
              className="img-fluid"
            />
            <p>
              <Link to="tel:+91-11-25693063">+91-11-25693063 </Link>
              <Link to="tel:+91-11-25693627"> | +91-11-25693627</Link>
            </p>
          </div>
          <div className="headlinkimg">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/mailicn.png"
              className="img-fluid"
            />
            <p>
              <Link to="mailto:tafsdelhi@gmail.com">
                tafsdelhi@gmail.com{" "}
              </Link>{" "}
            </p>
          </div>
        </div>
        <Highlights />
      </div>
      <div className="header fwidth">
        <div className="logo">
          <NavLink to="/">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/logo.png"
              alt="The Air Force School"
              className="img-fluid"
            />
          </NavLink>
        </div>
        <div className="headermid">
          <ul>
            <li>
              <Link to="/"> Home </Link>
            </li>
            <li>
              <Link to="/CareerCornerMissionMole">
                {" "}
                Career Corner : Mission N-MOLE{" "}
              </Link>
            </li>
            <li>
              <Link
                to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Tc-form.pdf"
                target="_blank"
              >
                {" "}
                TC Form{" "}
              </Link>
            </li>
            <li>
              <Link to="/TenderNotice"> Tender Notice </Link>
            </li>
            <li>
              <Link to="/Library"> TAFS Library </Link>
            </li>
            <li>
              <Link to="/SchoolCalendar"> School Calendar </Link>
            </li>
            <li>
              <Link to="/CatalystBoardCorner"> Catalyst: Board Corner </Link>
            </li>
            <li>
              <Link to="/Houses"> Houses </Link>
            </li>
            <li>
              <Link to="/Recruitment"> Recruitment </Link>
            </li>
            <li>
              <Link to="/InterSchoolCorner"> Inter-School Corner </Link>
            </li>
          </ul>
          <div className="headermidbottom">
            <div className="celebrate bounce2">
              <Link to="/RaisingDay2026">
                {" "}
                Raising Day 2026
              </Link>
            </div>
            <Link to="/MandatoryPublicDisclosure">
              Mandatory Public Disclosure
            </Link>
            <Link to="https://tafs.campuscare.info/" target="_blank">
              {" "}
              Login
            </Link>
          </div>
        </div>
        <div className="headerright">
          <ul>
            <li>
              <Link to="">
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/insta.png"
                  alt="The Air Force School"
                  className="img-fluid"
                />{" "}
              </Link>
            </li>
            <li>
              <Link to="">
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/fb.png"
                  alt="The Air Force School"
                  className="img-fluid"
                />{" "}
              </Link>
            </li>
            <li>
              <Link to="">
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/youtube.png"
                  alt="The Air Force School"
                  className="img-fluid"
                />{" "}
              </Link>
            </li>
            <li>
              <Link to="">
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/twiter.png"
                  alt="The Air Force School"
                  className="img-fluid"
                />{" "}
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="header-nav">
        <nav className="navbar navbar-expand-lg">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#main_nav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="main_nav">
            <ul className="navbar-nav">
              <li className="nav-item">
                {" "}
                <NavLink className="nav-link" to="/">
                  {" "}
                  Home{" "}
                </NavLink>
              </li>
              <li className="nav-item dropdown">
                <div className="nav-link" data-bs-toggle="dropdown">
                  {" "}
                  About Us{" "}
                </div>
                <ul className="dropdown-menu fade-up">
                  <li>
                    <NavLink to="/History">History </NavLink>
                  </li>
                  <li>
                    <NavLink to="/VisionMission">Vision and Mission </NavLink>
                  </li>
                  <li>
                    <NavLink to="/ManagementCommitee">
                      Management Commitee{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/PrincipalsMessage">
                      Principal's Message{" "}
                    </NavLink>
                  </li>
                  <li className="innersubmenu">
                    <a href="javascript:void(0)" className="menu-item">
                      {" "}
                      Prefectorial Board{" "}
                      <span>
                        <i class="bi bi-caret-right-fill"></i>
                      </span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <NavLink to="/JuniorBoard">Junior Board </NavLink>
                      </li>
                      <li>
                        <NavLink to="/SeniorBoard">Senior Board </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink to="/Faq">FAQ </NavLink>
                  </li>
                  <li>
                    <NavLink to="/SchoolInformation">
                      School Information - CBSE{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/ContactUs">Contact Us </NavLink>
                  </li>

                  <li>
                    <NavLink to="/SchoolVideos">School Videos </NavLink>
                  </li>
                        <li className="innersubmenu">
                    <a href="javascript:void(0)" className="menu-item">
                      {" "}
                      Raising Day{" "}
                      <span>
                        <i class="bi bi-caret-right-fill"></i>
                      </span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <NavLink to="/RaisingDay">2025 </NavLink>
                      </li>
                      <li>
                        <NavLink to="/RaisingDay2026">2026 </NavLink>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <div className="nav-link" data-bs-toggle="dropdown">
                  {" "}
                  Facilities{" "}
                </div>
                <ul className="dropdown-menu fade-up">
                  <li>
                    <NavLink to="/SchoolLibrary">School Library </NavLink>
                  </li>
                  <li>
                    <NavLink to="/BoardingHouse">Boarding House </NavLink>
                  </li>
                  <li>
                    <NavLink to="/SmartClassrooms">Smart Classrooms </NavLink>
                  </li>
                  <li>
                    <NavLink to="/ComputerEducation">
                      Computer education{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/SchoolTransport">School Transport </NavLink>
                  </li>
                  <li>
                    <NavLink to="/MiRoom">MI Room </NavLink>
                  </li>
                  <li>
                    <NavLink to="/SchoolCounsellor">School Counsellor </NavLink>
                  </li>
                  <li>
                    <NavLink to="/Laboratory">Laboratory </NavLink>
                  </li>
                  <li>
                    <NavLink to="/AudioVisualRoom">Audio Visual Room </NavLink>
                  </li>
                  <li>
                    <NavLink to="/MultiPurposeHall">
                      Multi Purpose Hall - The Aravali Hall{" "}
                    </NavLink>
                  </li>
                  <li className="innersubmenu">
                    <a href="javascript:void(0)" className="menu-item">
                      {" "}
                      Co-Scholastic Dept{" "}
                      <span>
                        <i class="bi bi-caret-right-fill"></i>
                      </span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <NavLink to="/Sports">Sports </NavLink>
                      </li>
                      <li>
                        <NavLink to="/ArtCraft">Art and Craft </NavLink>
                      </li>
                      <li>
                        <NavLink to="/DanceMusic">Dance And Music </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li className="innersubmenu">
                    <a href="javascript:void(0)" className="menu-item">
                      {" "}
                      Other Facilities{" "}
                      <span>
                        <i class="bi bi-caret-right-fill"></i>
                      </span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <NavLink to="/BookShop">Book Shop </NavLink>
                      </li>
                      <li>
                        <NavLink to="/UniformShop">Uniform Shop </NavLink>
                      </li>
                      <li>
                        <NavLink to="/Canteen">Canteen </NavLink>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <div className="nav-link" data-bs-toggle="dropdown">
                  {" "}
                  The Almanac{" "}
                </div>
                <ul className="dropdown-menu fade-up">
                  <li className="innersubmenu">
                    <a href="javascript:void(0)" className="menu-item">
                      {" "}
                      School Rules{" "}
                      <span>
                        <i class="bi bi-caret-right-fill"></i>
                      </span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <NavLink to="/CodeConduct">Code of Conduct </NavLink>
                      </li>
                      <li>
                        <NavLink to="/LibraryRules">Library Rules </NavLink>
                      </li>
                      <li>
                        <NavLink to="/PaymentFees">Payment of Fees </NavLink>
                      </li>
                      <li>
                        <NavLink to="/SchoolTiming">School Timing </NavLink>
                      </li>
                      <li>
                        <NavLink to="/AbsenceLeave">Absence and Leave </NavLink>
                      </li>
                      <li>
                        <NavLink to="/Withdrawal">Withdrawal </NavLink>
                      </li>
                      <li>
                        <NavLink to="/TransportRules">Transport Rules </NavLink>
                      </li>
                      <li>
                        <NavLink to="/BusRules">Bus Rules </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li className="innersubmenu">
                    <a href="javascript:void(0)" className="menu-item">
                      {" "}
                      School Planner{" "}
                      <span>
                        <i class="bi bi-caret-right-fill"></i>
                      </span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <NavLink to="/PlannerJunior">Planner (Junior) </NavLink>
                      </li>
                      <li>
                        <NavLink to="/PlannerSenior">Planner (Senior) </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink to="/HouseSystem">House System </NavLink>
                  </li>
                  <li>
                    <NavLink to="/Clubs">Clubs </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <div className="nav-link" data-bs-toggle="dropdown">
                  {" "}
                  Academics{" "}
                </div>
                <ul className="dropdown-menu fade-up">
                  <li>
                    <NavLink to="/HomeworkSchedule">Homework Schedule </NavLink>
                  </li>
                  <li>
                    <NavLink to="/ResultAnalysis">
                      Result Analysis-Classes X & XII{" "}
                    </NavLink>
                  </li>
                  <li className="innersubmenu">
                    <a href="javascript:void(0)" className="menu-item">
                      {" "}
                      List of Class Teachers{" "}
                      <span>
                        <i class="bi bi-caret-right-fill"></i>
                      </span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <NavLink to="/ClassTeacherListJunior">
                          Class Teacher List (Junior){" "}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/ClassTeacherListSenior">
                          Class Teacher List (Senior){" "}
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink to="/SchoolCalendar">School Calendar </NavLink>
                  </li>
                  <li>
                    <NavLink to="/BookList">
                      School Uniform &amp; Book List{" "}
                    </NavLink>
                  </li>
                  <li className="innersubmenu">
                    <a href="javascript:void(0)" className="menu-item">
                      {" "}
                      Examination Schedule & Scheme of Evaluation{" "}
                      <span>
                        <i class="bi bi-caret-right-fill"></i>
                      </span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <NavLink to="/JuniorExamination">
                          Junior (Examination){" "}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/SeniorExamination">
                          Senior (Examination){" "}
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink to="/HealthPhysicalEducationForms">
                      Health and Physical Education Forms{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/PortfolioTemplate">
                      Portfolio Template{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/CyberSafety">Cyber Safety </NavLink>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown">
                <div className="nav-link" data-bs-toggle="dropdown">
                  {" "}
                  Admissions{" "}
                </div>
                <ul className="dropdown-menu fade-up">
                  <li>
                    <NavLink to="/UKGAdmissions">
                      Entry Level Admissions 2026-2027{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/AdmissionServing">
                      Admission - Serving AF Personnel{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Tc-form.pdf"
                      target="_blank"
                    >
                      TC Form{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/ProformaForVerificationService">
                      Proforma for Verification of Service – AF Personnel{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/Tc">Transfer Certificate </NavLink>
                  </li>
                  <li>
                    <NavLink to="/FeeStructure">Fee Structure </NavLink>
                  </li>
                  <li>
                    <NavLink to="/BusRoutes">Bus Routes </NavLink>
                  </li>
                  <li>
                    <NavLink to="/ClassXIOptionForm">
                      Class XI - Option Form{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/CarryingParentguardian">
                      Carrying of Parent/Guardian ID{" "}
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                {" "}
                <NavLink className="nav-link" to="/Achievements">
                  Achievements{" "}
                </NavLink>{" "}
              </li>
              <li className="nav-item">
                {" "}
                <NavLink className="nav-link" to="/Gallery">
                  Gallery{" "}
                </NavLink>{" "}
              </li>

              <li className="nav-item">
                {" "}
                <NavLink className="nav-link" target="_blank" to="https://tafs.campuscare.info/">
                  {" "}
                  Portal Alumni Link
                </NavLink>{" "}
              </li>
              <li className="nav-item">
                {" "}
                <NavLink className="nav-link" to="/Recruitment">
                  {" "}
                  Recruitment{" "}
                </NavLink>{" "}
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
